import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  close: {
    color: '#ffae49',
    composes: ['is-bold'],
    fontSize: 12,
  },
});

const RideTooltipCloseFooterComponent = React.memo(({ closeProps }) => {
  const classes = useStyles();
  return (
    <button className={classes.close} type="button" {...closeProps}>
      <span>Fermer</span>
    </button>
  );
});

RideTooltipCloseFooterComponent.propTypes = {
  closeProps: PropTypes.shape().isRequired,
};

RideTooltipCloseFooterComponent.displayName = 'RideTooltipCloseFooterComponent';

export default RideTooltipCloseFooterComponent;
